const VERSION_UPDATE_RELOAD_KEY = "aruza.version-update.last-reload-at.v1";
const VERSION_UPDATE_PROMPT_VERSION_KEY = "aruza.version-update.last-prompted-version.v1";
const VERSION_UPDATE_PROMPT_AT_KEY = "aruza.version-update.last-prompted-at.v1";
const VERSION_UPDATE_PROMPT_COOLDOWN_MS = 24 * 60 * 60 * 1000;

export function wasVersionUpdateReloadedRecently(now = Date.now()): boolean {
    try {
        const storedReloadedAt = window.localStorage.getItem(VERSION_UPDATE_RELOAD_KEY);
        if (storedReloadedAt === null) return false;

        const reloadedAt = Number(storedReloadedAt);
        const elapsed = now - reloadedAt;

        return (
            Number.isFinite(reloadedAt) &&
            elapsed >= 0 &&
            elapsed < VERSION_UPDATE_PROMPT_COOLDOWN_MS
        );
    } catch (error) {
        console.error("Failed to read the version update reload timestamp", error);
        return false;
    }
}

export function recordVersionUpdateReload(now = Date.now()): void {
    try {
        window.localStorage.setItem(VERSION_UPDATE_RELOAD_KEY, String(now));
    } catch (error) {
        console.error("Failed to save the version update reload timestamp", error);
    }
}

function isSameLocalCalendarDay(a: number, b: number): boolean {
    const dateA = new Date(a);
    const dateB = new Date(b);

    return (
        dateA.getFullYear() === dateB.getFullYear() &&
        dateA.getMonth() === dateB.getMonth() &&
        dateA.getDate() === dateB.getDate()
    );
}

export function wasVersionUpdatePromptedToday(version: string, now = Date.now()): boolean {
    try {
        const storedVersion = window.localStorage.getItem(VERSION_UPDATE_PROMPT_VERSION_KEY);
        const storedPromptedAt = window.localStorage.getItem(VERSION_UPDATE_PROMPT_AT_KEY);
        if (storedVersion === null || storedPromptedAt === null) return false;
        if (storedVersion !== version) return false;

        const promptedAt = Number(storedPromptedAt);
        if (!Number.isFinite(promptedAt)) return false;

        return isSameLocalCalendarDay(promptedAt, now);
    } catch (error) {
        console.error("Failed to read the version update prompt state", error);
        return false;
    }
}

export function recordVersionUpdatePrompt(version: string, now = Date.now()): void {
    try {
        window.localStorage.setItem(VERSION_UPDATE_PROMPT_VERSION_KEY, version);
        window.localStorage.setItem(VERSION_UPDATE_PROMPT_AT_KEY, String(now));
    } catch (error) {
        console.error("Failed to save the version update prompt state", error);
    }
}
